import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadReportTemplateListFailed, loadReportTemplateListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* loadReportTemplateList(action) {
  try {
    const {
      payload = {
      },
    } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
    } = payload;
    let pool = {
      limit,
      page,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }
    const url = `${BACKEND_URL}/resources/report-templates`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadReportTemplateListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadReportTemplateListFailed());
      yield call(rejectActionPromise(action, data.data));
    }
    /*
    yield put(loadReportTemplateListSuccessful({
      data: [
        {
          id: 1,
          name: 'Информация о рассмотрении сотрудниками государственных услуг по Федеральному закону № 580',
          service: '',
          source: '',
          created_at: '2025-01-18 15:00:00',
          status: 'Активный',
        },
        {
          id: 2,
          name: 'Информация о перевозчиках по основанию владения транспортным средством',
          service: '',
          source: '',
          created_at: '2025-01-18 15:00:00',
          status: 'Активный',
        },
        {
          id: 3,
          name: 'Информация о количестве обращений по месяцам по государственным услугам',
          service: '',
          source: '',
          created_at: '2025-01-18 15:00:00',
          status: 'Активный',
        },
        {
          id: 4,
          name: 'Информация о результатах рассмотрения обращений государственных услуг по Федеральному закону № 580-ФЗ Комитетом по транспорту',
          service: '',
          source: '',
          created_at: '2025-01-18 15:00:00',
          status: 'Активный',
        },
        {
          id: 5,
          name: 'Отчет о ведении региональных реестров по месяцам',
          service: '',
          source: '',
          created_at: '2025-01-18 15:00:00',
          status: 'Активный',
        },
      ],
      meta: {
        limit: 10,
        page: 1,
        total: 5,
      },
    }));
     */
  } catch (e) {
    yield put(loadReportTemplateListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
